import { gql } from "@apollo/client";

export const Get_Appointments = gql`
  query GetAppointments(
    $skip: Int
    $take: Int
    $where: AppointmentFilterInput
    $order: [AppointmentSortInput!]
  ) {
    appointments(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        title
        organizer
        guest
        serviceType
        status
        calendarId
        memberId
        participantId
        leadId
        notes
        startDate
        endDate
        timeZone
        meetingLocationType
        customMeetingLocation
        eventSource
        leadSource
      }
    }
  }
`;

export const Get_Purchased_SMS_Number = gql`
  query GetPurchasedSMSNumber {
    generalSettings {
      appointmentSetting {
        smsNumber
        status
        createdOn
      }
    }
  }
`;
